//引入mock.js
import Mock from 'mockjs'

// 定义一个省份缩写的数组
const provinces = ['京', '津', '冀', '晋', '蒙', '辽', '吉', '黑', '沪', '苏', '浙', '皖', '闽', '赣', '鲁', '豫', '鄂', '湘', '粤', '桂', '琼', '川', '贵', '云', '渝', '藏', '陕', '甘', '青', '宁', '新'];

// 模拟数据
Mock.mock('/mock/vehiclePassRecords', 'post', function (options) {
    const params = JSON.parse(options.body);

    const pageSize = params.pageSize || 10; // 默认每页显示10条记录
    const pageNum = params.pageNum || 1; // 默认显示第一页
    const type = params.type; // 进场/出场类型，可以为空
    const licensePlate = params.licensePlate; // 车牌号，可以为空
    const searchTimes = params.time || []; // 搜索的时间范围，可以为空

    const total = 50; // 模拟总记录数

    const currentDate = new Date(); // Get current date
    const currentMonthDays = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate(); // Get the number of days in the current month
    const randomDay = Mock.Random.integer(1, currentMonthDays);
    const randomTime = Mock.Random.time('HH:mm:ss'); // Generate a random time
    const dateTime = new Date(currentDate.getFullYear(), currentDate.getMonth(), randomDay, ...randomTime.split(':'));

    const data = Mock.mock({
        [`data|${pageSize}`]: [{
            "id|+1": (pageNum - 1) * pageSize + 1,
            "province|1": provinces, // 随机选择一个省份缩写
            "plateNumber|5-6": /[A-Z0-9]/, // 随机生成车牌号的字母和数字序列
            "ownerName": "@cname", // 随机生成车主姓名
            "ownerPhone": /^1[3456789]\d{9}$/, // 随机生成车主电话
            "type|1": type !== undefined ? type : [0, 1], // 如果有传入type参数，则使用传入的值，否则随机生成
            // "time": "@datetime('yyyy-MM-dd HH:mm:ss')", // 随机生成日期和时间
            "time": dateTime.toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }), // 格式化日期和时间
            "licensePlate": function() {
                return this.province + this.plateNumber; // 将省份缩写和车牌号拼接起来
            },
            "image": function () {
                // 通过函数生成图片 URL，参数分别为尺寸、背景色、文字颜色、图片格式、文字内容（这里使用车牌号）
                return Mock.Random.image('100x60', Mock.Random.color(), '#757575', 'png', this.licensePlate);
            }
        }]
    }).data;
    // 添加几个非必填的字段，在请求接口的时候，来实现搜索，字段为 type(精确匹配)，licensePlate（模糊搜索），time（注意，传入的是一个数组，时间返回，需要去匹配哪些time在这个数组返回内）

    const flattenedData = data.flat().sort((a, b) => new Date(b.time) - new Date(a.time));
    // 根据非空的搜索条件过滤数据
    const filteredData = flattenedData.filter(item => {
        return (type === undefined || item.type === type) &&
            (licensePlate === undefined || item.licensePlate.includes(licensePlate)) &&
            (searchTimes.length === 0 || searchTimes.includes(item.time));
    });

    return {
        "status": 200,
        "data": filteredData,
        "total": total
    };
});

Mock.mock('/mock/echartsArr', 'post', function (config) {
    const { days } = JSON.parse(config.body);
    let mockData;
    if (days === 7) {
        mockData = generateRecords(7);
    } else if (days === 30) {
        mockData = generateRecords(30);
    } else {
        return Mock.mock({ code: 400, message: 'Invalid number of days' });
    }

    return Mock.mock({ code: 200, data: mockData });
});

const generateRecords = (days) => {
    const currentDate = new Date();
    const records = [];

    for (let i = days - 1; i >= 0; i--) {
        const date = new Date(currentDate);
        date.setDate(currentDate.getDate() - i);

        records.push({
            date: date.toISOString().split('T')[0],
            in: Mock.Random.integer(100, 1000),
            out: Mock.Random.integer(100, 1000),
        });
    }

    return records;
};


const paramsList = [
    { product: 'iphone3G', id: 1 },
    { product: 'iphone4', id: 2 },
    { product: 'iphone4S', id: 3 },
]

//增加数据接口：
Mock.mock('/mock/addInfo','post',options=>{
    let body = JSON.parse(options.body) // 获取请求参数
    let id = parseInt(body.id)
    let flag = true

    for (let item of paramsList) {
        if (item.id === id) flag = false // 判断id是否已经存在
    }

    // 如果id不存在
    if (flag) {
        paramsList.push(
            {
                product: body.product,
                id
            }
        )
        return {
            paramsList,
            status: 200,
            msg: '添加成功'
        }
    }
    // 如果id已存在
    return {
        status: 400,
        msg: '添加失败，id已存在'
    }
})

//删除数据接口
Mock.mock('/mock/remove', 'delete', options => {
    let id = parseInt(JSON.parse(options.body).id) // 获取请求id
    let index = null

    for (let i in paramsList) {
        if (paramsList[i].id === id) index = i // 获取id对应的index
    }

    if (index !== null) {
        console.log(`删除的id为：${id}，对应的index为：${index}`)
        paramsList.splice(index, 1) // 从index开始删除一个（本身）
        return {
            paramsList,
            status: 200,
            msg: '删除成功'
        }
    }
    return {
        status: 400,
        msg: '删除失败，id不存在'
    }
})

//修改数据接口
Mock.mock('/mock/edit', 'put', options => {
    const body = JSON.parse(options.body) // 解析请求参数（只能解析到这）
    const id = parseInt(body.id) // 获取请求id
    let index = null

    for (let i in paramsList) {
        if (paramsList[i].id === id) { // 判断id是否已经存在
            index = i // 拿到id对应的index
        }
    }

    // 如果id存在
    if(index != null){
        paramsList[index].product = body.product
        return {
            paramsList,
            status: 200,
            msg: '修改成功'
        }
    }
    return {
        status: 400,
        msg: '修改失败'
    }
})
